module.exports = __webpack_public_path__ + "d21835042110aed9653c73316d13cc74.png";